import React from "react";
import styles from "./Header.module.css";
import { Container } from "react-bootstrap";

const Header = ({ image, title, bold, desc }) => {
  return (
    <div className={`header ${styles.header}`}>
      <img className={styles.headerImg} src={image} alt="" />
      <Container>
        <h1 className={styles.headerTitle}>
          {title} <span>{bold}</span>
        </h1>
        <h1 className={styles.headerDesc}>{desc}</h1>
      </Container>
    </div>
  );
};

export default Header;
